import React from "react";

const Experience = (props) => {
  return (
    <div
      className=" card yellow center aligned"
      style={{ backgroundColor: "#E4E9B0", width: "350px" }}
    >
      <div className="content">
        <div className="center aligned header">{props.name}</div>
        <div className="center aligned meta">{props.position}</div>
        <div className="description">
          <p>{props.desc}</p>
        </div>
      </div>
      <div className="extra content">{props.date}</div>
    </div>
  );
};

export default Experience;
